import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    cnpjDados: [],
    loading: false,
    error: null,
    dadosCadastro: {},
    planoEscolhido: {},
    loadingAutocompleteCnpj: false,
    respostaEnviar: {},
    situacaoPagamento: {},
    assinaturaTransacaoID: null,
    ehFreemium: false,
    cupom: '',
    cupomInfo: {
        loading: false,
        data: {},
        error: null
    }
};

export const utilsSlice = createSlice({
    name: 'utils',
    initialState,
    reducers: {
        resetState: () => initialState,
        fetchCnpjStart: (state, action) => {
            state.loading = true;
            state.error = null;
            const cnpj = action.payload;
        },
        fetchCnpjSuccess: (state, action) => {
            state.cnpjDados = action.payload;
            state.loading = false;
        },
        fetchCnpjFailure: (state, action) => {
            state.loading = false;
            state.error = action.payload;
        },
        limparCnpjAction: (state) => {
            state.cnpjDados = [];
        },
        loadingAutocompleteCnpjTrue: (state) => {
            state.loadingAutocompleteCnpj = true;
        },
        loadingAutocompleteCnpjFalse: (state) => {
            state.loadingAutocompleteCnpj = false;
        },
        enviarDadosAction: (state, action) => {
            //state.loading = true;
            const dadosEnviar = action.payload;
        },
        salvarDadosAction: (state, action) => {
            state.dadosCadastro = { ...action.payload };
        },
        salvarPlanoAction: (state, action) => {
            state.planoEscolhido = { ...action.payload };
        },
        limparDadosAction: (state) => {
            state.dadosCadastro = {};
        },
        enviarDadosSuccess: (state, action) => {
            state.loading = false;
            state.respostaEnviar = action.payload;
        },
        enviarDadosFailure: (state) => {
            state.loading = false;
            state.respostaEnviar = { mensagem: 'Network Error' };
        },
        limparDadosEnvioPagamento: (state) => {
            state.respostaEnviar = {};
        },
        salvarSituacaoPagamento: (state, action) => {
            state.situacaoPagamento = action.payload
        },
        verificarPagamentoAction: (state, action) => {
            const assinaturaID = action.payload
        },
        assinaturaTransacaoIDAction: (state, action) => {
            state.assinaturaTransacaoID = action.payload
        },
        limparAssinaturaTransacaoIDAction: (state) => {
            state.assinaturaTransacaoID = null
        },
        enviarAssinaturaTransacaoID: (state, action) => {
            const assinaturaTransacaoID = action.payload
        },
        setarFreemium: (state, action) => {
            state.ehFreemium = action.payload
        },
        adicionarCupom: (state, action) => {
            state.cupom = action.payload
        },
        limparCupom: (state) => {
            state.cupom = ''
            state.cupomInfo = { loading: false, data: {}, error: null }
        },
        verificarCupomStart: (state) => {
            if (!state.cupomInfo) {
                state.cupomInfo = { loading: false, data: {}, error: null };
            }
            state.cupomInfo.loading = true;
            state.cupomInfo.error = null;
        },
        verificarCupomSuccess: (state, action) => {
            state.cupomInfo.loading = false;
            state.cupomInfo.data = action.payload;
        },
        verificarCupomFailure: (state, action) => {
            state.cupomInfo.loading = false;
            state.cupomInfo.error = action.payload;
        },
    },
});

export const {
    resetState,
    fetchCnpjStart,
    fetchCnpjSuccess,
    fetchCnpjFailure,
    limparCnpjAction,
    loadingAutocompleteCnpjTrue,
    loadingAutocompleteCnpjFalse,
    enviarDadosAction,
    salvarDadosAction,
    salvarPlanoAction,
    limparDadosAction,
    enviarDadosSuccess,
    enviarDadosFailure,
    limparDadosEnvioPagamento,
    salvarSituacaoPagamento,
    verificarPagamentoAction,
    assinaturaTransacaoIDAction,
    limparAssinaturaTransacaoIDAction,
    enviarAssinaturaTransacaoID,
    setarFreemium,
    adicionarCupom,
    verificarCupomFailure,
    verificarCupomStart,
    verificarCupomSuccess,
    limparCupom
} = utilsSlice.actions;
export default utilsSlice.reducer;
